import { render, staticRenderFns } from "./DetailCollectionPost.vue?vue&type=template&id=13aa3659&"
import script from "./DetailCollectionPost.vue?vue&type=script&lang=js&"
export * from "./DetailCollectionPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports